import React from 'react';
import PropTypes from 'prop-types';

import {
    Field,
} from 'redux-form';

import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

const Component = (props) => {
    const {
        input,
        meta: {
            touched,
            error,
        },
        label,
    } = props;

    const onDayClick = (day) => {
        input.onChange(day);
    };

    return (
        <label className="form-item" htmlFor={input.name}>
            <span className="form-item__label">
                {label}
            </span>
            <DayPicker
                className="form-item__field"
                onDayClick={onDayClick}
                selectedDays={input.value}
                disabledDays={{
                    before: new Date(),
                }}
                firstDayOfWeek={1}
                weekdaysShort={['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za']}
            />
            {touched && error && (
                <div className="form-item__error">{error[0]}</div>
            )}
        </label>
    );
};

Component.propTypes = {
    ...Field.props,
    label: PropTypes.string.isRequired,
};

export default Component;



// WEBPACK FOOTER //
// ./resources/components/forms/components/DateField.jsx